export default __webpack_public_path__ + "static/media/441.57e5a4ab.gif";